import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../Services/PasswordResetService';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: FormEvent): Promise<void> => {
        e.preventDefault();
        setError('');

        if (!email.trim()) {
            setError('Por favor, introduce tu email');
            return;
        }

        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('El formato de email no es válido');
            return;
        }

        try {
            setLoading(true);
            await requestPasswordReset(email);
            setSubmitted(true);
        } catch (err) {
            setError('Ha ocurrido un error. Inténtalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="login-form-container">
                <div className="login-card">
                    <div className="login-card-body">
                        {/* Logo */}
                        <div className="text-center mb-4">
                            <img src="/logos/logo-complet.avif" alt="Logo" className="logo" style={{ maxWidth: '100%' }} />
                        </div>

                        {submitted ? (
                            <div>
                                <div className="alert alert-success" role="alert">
                                    Si el email existe en nuestro sistema, recibirás un enlace de recuperación.
                                </div>
                                <p className="text-muted text-center mt-3" style={{ fontSize: '0.9rem' }}>
                                    Revisa tu bandeja de entrada y la carpeta de spam.
                                </p>
                                <div className="text-center mt-4">
                                    <Link to="/" className="link-primary">
                                        Volver al inicio de sesión
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <>
                                <p className="text-muted text-center mb-4" style={{ fontSize: '0.9rem' }}>
                                    Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.
                                </p>

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className={`form-control ${error ? 'is-invalid' : ''}`}
                                            id="email"
                                            value={email}
                                            onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                            placeholder="tu@email.com"
                                            disabled={loading}
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100 py-2 mt-3"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Enviando...
                                            </>
                                        ) : 'Enviar enlace de recuperación'}
                                    </button>
                                </form>

                                <div className="text-center mt-3">
                                    <Link to="/" className="link-primary">
                                        Volver al inicio de sesión
                                    </Link>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
